import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment'

export default {
  name: 'AgentScanTally',
  components: {
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        hubname : '',
        dateobj : {
          toDate : ''
        },
        hubServiceCenterList : [],
        shipmentDetailsFlag : false,
        scanShipmentBatchFlag : false,
        showBatchesFlag : false,
        comments : '',
        shippingId :'',
        localusermailid :'',
        localuserid : '',
        rolename : '',
        max:500,
        shipmentStatusType: '',
        errormsg : [],
        Ismannual : 'true',
        checkValue : 0,
        BatchNo : '',
        OutSourcingMasterId : '',
        getSummaryObj : [],
        getShipmentScanObj : [],
        Loading : false,
        file : '',
        scanFlag : false,
        validated : true,
        batchStatus : '',
        styleObject : {
          'margin-bottom' : '15px',
          'background-color' : '#fff'
        },
        OverageShipmentError : '',
        IsImageUploadRequired : false,
        changeStatus : '1',
        ScanTally : '1',
        Audit : '0',
        Include : '',
        exclude : '',
        commentsObjList : [],
        excludeList : [{"eId":"OFD","excludeName":"OFD Shipments"}],
        IncludeList : [{"IncludeId":"BagIn","IncludeName":"BagIn Shipments"}],
        imageListObject : [],
        getShipmentList : [],
        ShipmentDetailsLoading : false,
        commentsForManualEntry:[{text:'Barcode Damage',value:'1'},{text:'Unable to scan Barcode',value:'2'}],
        toggleFlag:false,
        SetReadonlyMode: true,
        InscanLoading: false,
        dismissSecs: 15,
        dismissCountDown: 0,
        dismissCountDownSuccess:0,
        keyFiredCount: {'value':0},
        uploadLoading: false,
        generateBatchLoader: false,
        shipmentDetailsModel:false,
        isCloseButtonUpload: false,
        invalidFile: {},
        roleWiseAudit: false,
        roleWiseScantally: true,
        getModelBatchNo: '',
        userDataKey : '',
      }
  },
  created: function() {
    this.getHubList();
    this.changeDateFormat();
    this.getAuditCommentList();
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    //  console.log('userdetail',userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    // console.log('this.rolename', this.rolename);
    this.hubname = userdetail.hubdetails[0];
    this.OutSourcingMasterId = userdetail.outsourcingid;
    //console.log('this.hubdetails',this.hubdetails)
    // this.roleWiseScantally = this.rolename.toLowerCase().trim() == 'admin' || this.rolename.toLowerCase().trim() == 'executive' ?  true : false;
    // this.roleWiseAudit = this.rolename.toLowerCase().trim() == 'admin' ?  true : false;
    //console.log('Mixin is working for :',result);
    // this.getScanTallyObject();
    const vm = this;
    var keyupFiredCount = 0;
      $("#shippingId").keyup(this.DelayExecution(function (event) {
      let keycode = (event.keyCode ? event.keyCode : event.which);
      vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
      vm.oncallImediate(keycode);
      vm.setIsMannual();
    }));

    // $("#shippingId").keydown(function (event) {
    //    var keycode = (event.keyCode ? event.keyCode : event.which);
    //    if ($(this).val() == '') {
    //       keyupFiredCount = 0;
    //    }
    //    if (keycode == 13) {
    //      $("#submitControl").focus();
    //      return false;
    //      event.stopPropagation();
    //    }
    //  });

    // $("#shippingId").mouseup(function (event) {
    //     if ($("#shippingId").val() == ''){
    //       console.log('keypressedd.!!!');
    //         return false;
    //     }
    //     if(keyupFiredCount <= 1) {
    //         vm.IsmannulCheck('B');
    //     } else {
    //         vm.IsmannulCheck('M');
    //         console.log('manuual rigtht');
    //     }
    //     keyupFiredCount = 0;
    // });
  },
  methods : {
    oncallImediate(keycode){
      if ($("#shippingId").val() == ''){
          this.keyFiredCount.value = 0;
          this.comments = '';
          return false;
      }
      if(this.keyFiredCount.value <= 1 && keycode == 13) {
          this.Ismannual = false;
          this.checkValue = 0;
          this.keyFiredCount.value = 0;
      } else {
        this.Ismannual = true;
        this.checkValue = 1;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
            f.apply(context, args);
        },
        delay || 30);
      };
    },
    setIsMannual(){
      if(this.shippingId == '' ) {
        this.Ismannual = false;
        this.checkValue = 0;
      }
    },
    IsmannulCheck(typests){
      if(typests == 'B'){
        this.Ismannual = false;
        this.checkValue = 0;
        //this.validateForm('form-1');
      } else {
        this.Ismannual = true;
        this.checkValue = 1;
      }
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result) {
            this.InscanLoading = true;
            this.getShipmentScanObj = [];
            if(this.batchStatus.toLowerCase().trim() == 'closed'){
              this.$alertify.error("Batch already closed.");
            } else {
              let ScanTallyModule = {
                "ShippingID" : (this.shippingId).replace(/\s/g, '')
              }

              axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/shipment/get', ScanTallyModule)
               .then((response) => {

                   let inscanPayload = {};

                   let string_substr = this.shippingId.trim().substr(0, 3);
                   let IsRECShipments;
                   if(string_substr.toLowerCase().trim() == 'rec' ){
                     IsRECShipments = true;
                   }else{
                     IsRECShipments = false;
                   }
                   let responseFields = {};
                   if(response.data.code === 200 && ( response.data.data.ShipmentStatus.toLowerCase().trim() != 'pending' && response.data.data.Status.toLowerCase().trim() != 'pending') ) {
                       let resultObj = response.data.data;
                       //console.log('resultObj',resultObj);
                       responseFields.TotalAttemptCount = resultObj.TotalAttemptCount;
                       let reattemptFormatDate = resultObj.ReAttemptDate != null ? moment(resultObj.ReAttemptDate).format('YYYY-MM-DD HH:mm:ss') : '';
                       responseFields.ReAttemptDate = reattemptFormatDate;
                       responseFields.NotificationStatus = resultObj.NotificationStatus;
                       responseFields.PDD = resultObj.pdd;
                       responseFields.LastComments = resultObj.LastComments

                       this.OverageShipmentError = '';
                       //background colors validations
                       if(resultObj.ShipmentStatus.toLowerCase().trim() == 'inscan' && resultObj.Status.toLowerCase().trim() != 'rto'){
                         this.styleObject = {
                           "background-color" : "Silver"
                         }
                       } else  if(resultObj.ShipmentStatus.toLowerCase().trim() == 'lost'){
                         this.styleObject = {
                           "background-color" : "greenyellow"
                         }
                       } else  if(resultObj.Status.toLowerCase().trim() == 'rto'){
                         this.styleObject = {
                           "background-color" : "red"
                         }
                       } else  if(resultObj.ShipmentStatus.toLowerCase().trim() == 'std'){
                         this.styleObject = {
                           "background-color" : "aquamarine"
                         }
                       } else  if(resultObj.ShipmentStatus.toLowerCase().trim() == 'handover'){
                         this.styleObject = {
                           "background-color" : "skyblue"
                         }
                       } else  if(resultObj.ShipmentStatus.toLowerCase().trim() == 'whhandover'){
                         this.styleObject = {
                           "background-color" : "lightsalmon"
                         }
                       } else  if(resultObj.ShipmentStatus.toLowerCase().trim() == 'overage'){
                         this.styleObject = {
                           "background-color" : "forestgreen"
                         }
                       } else  if(resultObj.ShipmentStatus.toLowerCase().trim() == 'nts'){
                         this.styleObject = {
                           "background-color" : "deepskyblue"
                         }
                       } else {
                         this.styleObject = {
                           "background-color" : "Silver"
                         }
                       }
                       if(resultObj.NotificationStatus != null && resultObj.NotificationStatus.toLowerCase().trim() == 'reattempt'){
                           if(resultObj.ReAttemptDate != null){
                             let currentDate = new Date();
                             let formatDate = moment(currentDate).format('YYYY-MM-DD');
                             let ReAttemptDate = moment(resultObj.ReAttemptDate).format('YYYY-MM-DD');
                             let checkSameDay = moment(formatDate).isSame(ReAttemptDate);
                             if(checkSameDay){
                                 this.styleObject = {
                                   "background-color" : "LightGreen"
                                 }
                               } else{
                                 this.styleObject = {
                                   "background-color" : "YellowGreen"
                                 }
                               }
                          }
                       } else if(resultObj.NotificationStatus != null && resultObj.NotificationStatus.toLowerCase().trim() == 'escalation'){
                           this.styleObject = {
                             "background-color" : "DarkOrange"
                           }
                       } else if( resultObj.NotificationType != null && resultObj.NotificationType.toLowerCase().trim() == 'rto'){
                         this.styleObject = {
                           "background-color" : "LightCoral"
                         }
                       }

                      let OutSourcingMasterId = this.OutSourcingMasterId;
                      let IsInscan = true;
                      let IsOverage = '';
                      let IsNTSOverage = '';
                      if(resultObj.CurrentHubID != this.hubname ||
                          resultObj.ShipmentStatus.toLowerCase().trim() == "lost" ||
                          resultObj.ShipmentStatus.toLowerCase().trim() == "overage" ||
                          resultObj.IsOFDShipment == true || this.OutSourcingMasterId != resultObj.OutSourcingMasterId) {
                          // (resultObj.ShipmentStatus.toLowerCase().trim() == "delivered" && resultObj.IsUpdatedLater == true ) ||
                          //  resultObj.ShipmentStatus.toLowerCase().trim() == "whhandover") {
                          IsOverage = true;
                       } else{
                         IsOverage = false;
                       }
                       if((['pickupdone','pickdone'].includes(resultObj.ShipmentStatus.toLowerCase()) && resultObj.Status.toLowerCase().trim() == 'pending') || (resultObj.ShipmentStatus.toLowerCase().trim() == 'pending' && resultObj.Status.toLowerCase().trim() == 'pending')){
                         IsNTSOverage = true
                       } else {
                         IsNTSOverage = false
                       }
                      inscanPayload = {

                        OutScourcingMasterId: OutSourcingMasterId,
                        HubID: this.hubname,
                        ShippingID: resultObj.ShippingId,
                        ServiceType: resultObj.ServiceType,
                        BatchID: this.BatchNo,
                        Status: resultObj.Status,
                        ShipmentStatus: resultObj.ShipmentStatus,
                        NotificationType: resultObj.NotificationType,
                        DeliveryStatus: 'null',
                        CurrentHubId: resultObj.CurrentHubID,
                        FinalDestinationID: resultObj.FinalDestinationID,
                        IsReversePick: resultObj.IsReversePick,
                        IsSupplierPick: resultObj.IsSupplierPick,
                        IsInscan: IsInscan,
                        IsOverage: IsOverage,
                        LastModifiedBy: this.localusermailid,
                        SMCreatedDate: resultObj.LastModifiedDate,
                        Comments: this.comments,
                        OctroiMRP: resultObj.DeclaredValue,
                        NetPayment: resultObj.NetPayment,
                        ShippingDate: resultObj.CreatedDate,
                        OrderType: resultObj.OrderType,
                        IsNTSOverage: IsNTSOverage,
                        IsAPI: resultObj.IsAPI,
                        UpdateFrom: resultObj.UpdateFrom,
                        IsOFD: resultObj.IsOFDShipment,
                        IsSeized: resultObj.IsSeized,
                        IsUpdatedLater: resultObj.IsUpdatedLater,
                        IsRECShipments: IsRECShipments,
                        NotificationStatus: resultObj.NotificationStatus
                    }

                 } else {
                   this.styleObject = {
                     "background-color" : "Blueviolet",
                     "margin-bottom" : '15px'
                   }

                   responseFields.ReAttemptDate = '';
                   responseFields.NotificationStatus = '';
                   responseFields.PDD = '';

                   inscanPayload = {
                      BatchID : this.BatchNo,
                      IsInscan : true,
                      IsOverage : false,
                      IsNTSOverage : true,
                      IsRECShipments : IsRECShipments,
                      HubID : this.hubname,
                      ShippingID : this.shippingId,
                      ServiceType : "",
                      Status : "NoDataFound",
                      ShipmentStatus : "NoDataFound",
                      NotificationType : null,
                      DeliveryStatus : null,
                      CurrentHubId : null,
                      FinalDestinationID : null,
                      IsReversePick : false,
                      IsSupplierPick : false,
                      Comments: this.comments,
                      LastModifiedBy : this.localusermailid
                  }
                  let message = response.data.message ? response.data.message : 'Something went wrong!!'
                  this.$alertify.error(`Shipment cannot scanned, ${message}`);
                  this.InscanLoading = false;
                  return false;
                }
                if(this.batchStatus.toLowerCase().trim() == 'partialclose'){
                  inscanPayload.isPartialClose = true;
                } else {
                  inscanPayload.isPartialClose = false;
                }
                //console.log('inscanPayload',inscanPayload);
                //isPartialClose
                //iscan API Call start
                axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/inscan', inscanPayload)
                 .then((response) => {
                     if(response.data.code === 200){
                      let TrackerInfo = {
                        projectname:"Last Mile",
                        type:"Web",
                        userid:this.localuserid,
                        username:this.localusermailid,
                        meta: {
                            "event":"inscanScanTallyShipments",
                            "shippingId" : this.shippingId.toString(),
                            "BatchID" : this.BatchNo
                        }
                        }
                        this.PageTracker(TrackerInfo);
                       this.getShipmentScanObj = response.data.data;
                       // this.getShipmentScanObj.ReAttemptDate = responseFields.ReAttemptDate != null ? responseFields.ReAttemptDate : "";
                       // // this.getShipmentScanObj.NotificationStatus = responseFields.NotificationStatus;
                       // this.getShipmentScanObj.PDD = responseFields.PDD;
                       // this.getShipmentScanObj.TotalAttemptCount = responseFields.TotalAttemptCount;
                       this.$alertify.success("Successfully done");
                       if(this.file != '' && this.file != undefined) {
                         this.uploadFile(event)
                       }
                     } else if(response.data.code === 202){
                       this.getShipmentScanObj = response.data.data;
                       this.$alertify.error(response.data.data.ScanMessage);
                     } else {
                       this.getShipmentScanObj = response.data.data;
                       this.$alertify.error("Error");
                     }

                     this.getShipmentScanObj.ReAttemptDate = responseFields.ReAttemptDate != null ? responseFields.ReAttemptDate : "";
                     this.getShipmentScanObj.PDD = responseFields.PDD;
                     this.getShipmentScanObj.TotalAttemptCount = responseFields.TotalAttemptCount;
                     this.getShipmentScanObj.LastComments = responseFields.LastComments;

                     this.clearScanForm();
                     $("#shippingId").focus();
                     const el = this.$el.querySelector("#InscanResponse");
                      if (el) {
                        el.scrollIntoView();
                      }
                     this.InscanLoading = false;
                 })
                 .catch((httpException) => {
                     console.error('exception is:::::::::', httpException)
                     this.InscanLoading = false;
                 })
                 //iscan API Call end
                this.scanFlag = true;
               })
               .catch((httpException) => {
                   this.$alertify.error("Unable to scan batch");
                   this.InscanLoading = false;
                   console.error('exception is:::::::::', httpException)
               })
            }
        }
      }).catch(() => {
        this.InscanLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    getHubList(){
       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList =response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
    getAuditCommentList(){

       axios.get(apiUrl.api_url + 'external/getreasons?reasonType=stAudit', {})
        .then((response) => {
            if(response.data.code===200){
                this.commentsObjList =response.data.data;
            }
            else {
                this.commentsObjList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
    handleDragOver(event){
      event.preventDefault();
    },
    generateBatch(){
      this.errormsg = [];
      let scantAt = 'Agent';
      let OutSourcingMasterId = this.OutSourcingMasterId;
      let BatchType = this.changeStatus == 1 ? 'ScanTally' : 'Audit';
      let generateBatchPayload = {
        "CurrentHubID" : this.hubname,
        "OutSourcingMasterId" : OutSourcingMasterId != '' ? OutSourcingMasterId : null,
        "LastModifiedBy" : this.localusermailid,
        "ScanTallyAt" : scantAt,
        "BatchType" : BatchType,
        "StartTime" : null,
        "CloseTime" : null,
        "Source" : "",
        "ExcludeCriteria" : this.exclude,
        "IncludeCriteria" : this.Include
      }
      //console.log('this.rolename',generateBatchPayload);
      this.generateBatchLoader = true;
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/generatebatch', generateBatchPayload)
       .then((response) => {
           if(response.data.code === 200){
            let TrackerInfo = {
              projectname:"Last Mile",
              type:"Web",
              userid:this.localuserid,
              username:this.localusermailid,
              meta: {
                  "event":"generateBatch",
                  "ExcludeCriteria" : this.exclude,
                  "IncludeCriteria" : this.Include,
                  "OutSourcingMasterId" : OutSourcingMasterId != '' ? OutSourcingMasterId : null,
                  "scantAt" : 'Agent',
                  "BatchType" : this.changeStatus == 1 ? 'ScanTally' : 'Audit'
              }
              }
              this.PageTracker(TrackerInfo);
             //this.scanShipmentBatchFlag = true;
             this.BatchNo = response.data.BatchID;
             this.errormsg.push({
               "message" : response.data.message,
               "code" : response.data.code
             });
             this.changeDateFormat()
             this.showBatch()
             this.getSummaryObj = '';
             this.getBatchDetails();
             this.dismissCountDownSuccess = this.dismissSecs

             const el = this.$el.querySelector("#shippingId")
              if (el) {
                el.scrollIntoView();
              }
             this.batchStatus = 'ProcessDone'
             this.BatchNo = response.data.BatchID
             this.scanShipmentBatchFlag = true
             this.getShipmentScanObj = []
             this.scanFlag = false
             $("#shippingId").focus()
             this.getInscanImageList()
             this.clearScanForm()

           }else {
             this.errormsg.push({
               "message" : response.data.message,
               "code" : response.data.code
             });
             this.scanShipmentBatchFlag = false;
             this.getSummaryObj = '';
             this.showBatchesFlag = true;
             this.dismissCountDown = this.dismissSecs
          }
          this.generateBatchLoader = false;
          this.changeDateFormat();

       })
       .catch((httpException) => {
           this.scanShipmentBatchFlag = false;
           this.generateBatchLoader = false;
           this.$alertify.error("Unable to generate batch");
           console.error('exception is:::::::::', httpException)
       })
      //console.log('generate batch triggred',generateBatchPayload);
    },
    getBatchDetails(){
      //this.errormsg = [];
      this.Loading = true;
      // this.scanShipmentBatchFlag = false
      this.shipmentDetailsFlag = false;
      let scantAt = 'Agent';
      let OutSourcingMasterId = this.OutSourcingMasterId;
      let BatchType = this.changeStatus == 1 ? 'ScanTally' : 'Audit';
      this.showBatchesFlag = true;
      //this.BatchNo = '';
      //console.log('this.BatchNo',this.BatchNo);
      let batchPayload = {
        "HubID" : this.hubname,
        "FromDate" : this.dateobj.toDate,
        "BatchId" : '',
        "ScanTallyAt" : scantAt,
        "BatchType" : BatchType,
        "OutSourcingMasterId" : OutSourcingMasterId
      }
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/getSummary', batchPayload)
       .then((response) => {
          //console.log('response',response);
           if(response.data.code === 200){
             this.getSummaryObj = response.data.data;
             const el = this.$el.querySelector("#batchTable");
              if (el) {
                el.scrollIntoView();
              }
           } else if(response.data.code === 202){
             this.getSummaryObj = [];
           } else {
             this.getSummaryObj = [];
           }
           this.Loading = false;
       })
       .catch((httpException) => {
           this.Loading = false;
           this.scanShipmentBatchFlag = false;
           this.$alertify.error("Unable to get summary details");
           console.error('exception is:::::::::', httpException)
       })
       $("#shippingId").focus();
    },
    async CloseBatch(batchStatus,BatchId){
      this.Loading = true;
      // let tallyBeforeClose = await this.updateTallyFunctions(BatchId)
      // if (tallyBeforeClose) {
      let currentDateTime = new Date();
      let closeTime = currentDateTime.getHours() +''+ currentDateTime.getMinutes();
      let batchClosePayload = {
        "BatchID": BatchId,
        "CurrentHubID": this.hubname,
        "Status": batchStatus,
        "LastModifiedBy":this.localusermailid,
        "CloseTime": closeTime,
        "Source":"mannual"
      }
      //console.log('Payload: ',batchClosePayload);
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/closeBatch', batchClosePayload)
       .then((response) => {

           if(response.data.code === 200){
            let TrackerInfo = {
              projectname:"Last Mile",
              type:"Web",
              userid:this.localuserid,
              username:this.localusermailid,
              meta: {
                  "event":"closeBatch",
                  "Source":"Manual",
                  "BatchID": BatchId,
                  "CurrentHubID": this.hubname,
                  "Status": batchStatus,
              }
              }
              this.PageTracker(TrackerInfo);
             let closeType = batchStatus == 'partialClose' ? 'Partial Closed' : 'Closed';
             this.$alertify.success(`Batch ${closeType} Successfully`);
             //console.log('this.getSummaryObj',this.getSummaryObj);
             this.getBatchDetails();
           } else if(response.data.code === 202){
             this.$alertify.error('Invalid !! Batch Already Closed');
           } else {
             this.$alertify.error(response.data.message);
           }
           this.Loading = false;
           this.scanShipmentBatchFlag = false;
       })
       .catch((httpException) => {
           this.scanShipmentBatchFlag = false;
           this.$alertify.error("Unable to close batch");
           console.error('exception is:::::::::', httpException)
       })
      // }
    },
   showBatch(){
      this.getBatchDetails();
    },
    async TallyBatch(BatchID){
      let result = await this.updateTallyFunctions(BatchID)
      console.log('result', result);
    },
    updateTallyFunctions(BatchID){
      return new Promise((resolve, reject) => {
        this.Loading = true;
        let TallyBatchPayload = {
          "HubID": this.hubname,
          "BatchID":BatchID,
          "CreatedBy": this.localusermailid
        }
        axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/tallyBatch', TallyBatchPayload)
         .then((response) => {
             if(response.data.code === 200){
               this.$alertify.success('Shipment Scan Tally successful..');
               this.getBatchDetails();
             } else if(response.data.code === 202){
               this.$alertify.error('Invalid !! Batch details not available');
             } else {
               this.$alertify.error(response.data.message);
             }
             this.Loading = false;
             resolve(true)
         })
         .catch((httpException) => {
             this.scanShipmentBatchFlag = false;
             this.$alertify.error("Unable to Tally batch");
             resolve(false)
             console.error('exception is:::::::::', httpException)
         })
      })
    },
    updateBatch(batchId){
      this.Loading = true;
      let updateBatchPayload = {
        "HubID": this.hubname,
        "BatchID": batchId,
        "LastModifiedBy":this.localusermailid
      }
      //console.log('updateBatchPayload',updateBatchPayload);
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/updateBatch', updateBatchPayload)
       .then((response) => {
           if(response.data.code === 200){
             this.$alertify.success('updated batch tally successful..');
             this.getBatchDetails();
           } else if(response.data.code === 202){
             this.$alertify.error(response.data.message);
           } else {
             this.$alertify.error(response.data.message);
           }
           this.Loading = false;
       })
       .catch((httpException) => {
           this.$alertify.error("Unable to Tally update batch");
           console.error('exception is:::::::::', httpException)
       })
    },
    ReloadBatchData(){
      this.getBatchDetails();
      this.ResetForm()
    },
    scanShipments(batchId,batchStatus){
      const el = this.$el.querySelector("#shippingId");
       if (el) {
         el.scrollIntoView();
       }
      this.batchStatus = batchStatus;
      this.BatchNo = batchId;
      this.scanShipmentBatchFlag = true;
      this.getShipmentScanObj = [];
      this.scanFlag = false;
      $("#shippingId").focus();
      if(batchStatus.toLowerCase().trim() == 'partialclose'){
        this.IsImageUploadRequired = true;
      } else{
        this.IsImageUploadRequired = false;
      }
      this.clearScanForm();
      if(this.changeStatus == 1){
        this.getInscanImageList();
      }
    },
    exportShipmentData(batchId,downLoadType,isDownload){
      this.shipmentScanTallyList(batchId,downLoadType,isDownload);
    },
    closeshipmentDetailsModel() {

      this.shipmentDetailsModel = false;
    },
    shipmentScanTallyList(batchId,typeName,downLoadType = false) {
      // if(downLoadType == 'ExportTotalShipment'){
      //   this.shipmentDetailsFlag = false;
      // } else{
      //   this.shipmentDetailsFlag = true;
      // }
      this.getModelBatchNo = ''
      this.shipmentDetailsModel = false
      this.ShipmentDetailsLoading = true;
      this.shipmentStatusType = typeName;
      //this.BatchNo = batchId;
      this.shipmentDetailsModel = true;
      let searchTypePayload = {
        "BatchId": batchId,
        "SearchType" : typeName,
        "HubId": this.hubname,
      }
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/getshipments', searchTypePayload)
       .then((response) => {
           if(response.data.code === 200){
             this.getShipmentList = response.data.data;
             let getshipmentObjDetails = [];
             this.getShipmentList.forEach(function(item){
               getshipmentObjDetails.push({
                 "Batch ID":item.BatchID,
                 "Shipping ID": item.ShippingID,
                 "ScanTally InScan Date" : item.CreatedDate,
                 "Status":item.Status,
                 "Shipment Status" : item.ShipmentStatus,
                 "Current Hub Name" : item.CurrentHubName,
                 "Notification Type" : item.NotificationType,
                 "OctroiMRP" : item.OctroiMRP,
                 "NetPayment" : item.NetPayment,
                 "Shipping Date" : item.ShippingDate,
                 "LastProcessDate" : item.LastProcessDate,
                 "OrderType" : item.OrderType,
                 "GapDays" : item.GapDays,
                 "Comments" : item.Comments
                 }
               )
             });

             if(downLoadType){
               this.exportCsv(getshipmentObjDetails);
               // this.shipmentDetailsModel = false;
             }else {
               this.getModelBatchNo = batchId
             }
           } else if(response.data.code === 202){
             this.$alertify.error(response.data.data);
             this.getShipmentList = [];
           } else {
             this.$alertify.error("Error while getting shipment Details");
             this.getShipmentList = [];
           }
           this.ShipmentDetailsLoading = false;
       })
       .catch((httpException) => {
           this.ShipmentDetailsLoading = false;
           this.scanShipmentBatchFlag = false;
           this.$alertify.error("Unable to get summary details");
           console.error('exception is:::::::::', httpException)
       })

    },
    exportCsv(shipmentObjectdata){
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "ShipmentDetails" + today + ".csv";
      csvContent += [
        Object.keys(shipmentObjectdata[0]).join(";"),
        ...shipmentObjectdata.map(item => Object.values(item).join(";"))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    onuploadChange(event){
      const file = event.target.files[0];
      this.file = file;

      let FilterExtention = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png"];
      if(!FilterExtention.includes(this.file.type)){
        this.invalidFile.value = true;
        this.validated = false;
        this.invalidFile.errorMessage = 'Please upload only images.!';
        this.$alertify.error("Please upload only images");
      }else if(this.file.size >= 1024 * 1024 * 10){
        this.validated = true;
        this.invalidFile.value = true;
        this.invalidFile.errorMessage = 'Please check image size should be less than 10MB .!';
        this.$alertify.error("Please check image size should be less than 10MB ");
        const input = this.$refs.uploadfile;
        input.type = 'text';
        input.type = 'file';
        this.validated = false;
      } else {
        this.invalidFile = {};
        this.validated = true;
      }

      if(this.file != '' && this.file != undefined) {
        this.isCloseButtonUpload = true;
      } else {
        this.isCloseButtonUpload = false;
      }
      // console.log('this.file', this.file);
      // this.validated = true;
    },
    uploadFile(){
        if(!this.file){
          this.$alertify.error('Please selecct file');
        }else if(this.shippingId != '') {
          const formData = new FormData();
          formData.append('shippingId',this.shippingId);
          formData.append('BatchID',this.BatchNo);
          formData.append('file',this.file);
          let FilterExtention = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png"];
          if(!FilterExtention.includes(this.file.type)){
            this.$alertify.error("Please upload only images");
          }else if(this.file.size >= 1024 * 1024 * 10){
            this.validated = true;
            this.$alertify.error("Please check image size should be less than 10MB ");
            const input = this.$refs.uploadfile;
            input.type = 'text';
            input.type = 'file';
            this.validated = true;
          }else {
            this.validated = true;
            this.uploadLoading = true;
            axios.post(apiUrl.api_url_for_scantally + 'ScanTally/ShipmentScanTallyUpload', formData)
             .then((response) => {
                 if(response.data.code === 200){
                   this.getInscanImageList()
                   this.$alertify.success('uploaded Successfully');
                 } else if(response.data.code === 202){
                   this.$alertify.error('Upload failed');
                 } else {
                   this.$alertify.error(response.data.message);
                 }
                 this.uploadLoading = false;
             })
             .catch((httpException) => {
                 this.scanShipmentBatchFlag = false;
                 this.uploadLoading = false;
                 this.$alertify.error("Unable to upload file");
                 console.error('exception is:::::::::', httpException)
            })
          }
        }else{
          this.$alertify.error('Please Enter ShippingId before upload')
          document.getElementById('shippingId').focus();
        }
    },
    getInscanImageList(){
        let imgParamPayload = {
          "batchid" : this.BatchNo,
          "hubid": this.hubname
        }
        axios.post(apiUrl.api_url_for_scantally + 'ScanTally/shipmentInscanAttachmentDownload', imgParamPayload)
         .then((response) => {
           //console.log('response',response);
           if(response.data.code===200){
             this.imageListObject = response.data.data;
           } else {
             this.imageListObject=[];
             //this.$alertify.error(response.data.message);
           }
       })
       .catch((httpException) => {
           this.$alertify.error("No Records Found");
           console.error('exception is:::::::::', httpException)
       })
    },
    downloadFile(filePath){
      var link = document.createElement('a');
      link.href = filePath;
      link.setAttribute('target','_blank');
      window.open(filePath, '_blank');
      return true;
    },
    collapseUpslide(){
      var x = document.getElementById("hiddentable");
      if (x.style.display === "none") {
        this.toggleFlag = true
        x.style.display = "block";
      }else{
        this.toggleFlag = false
        x.style.display = "none";
      }

    },
    clearAll(){
      this.errormsg = [];
      this.scanShipmentBatchFlag = false;
      this.shipmentDetailsFlag = false
      this.showBatchesFlag = false;
      this.getSummaryObj = [];
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.$validator.reset();
      this.errors.clear();
      this.clearScanForm();

    },
    clearScanForm(){
      console.log('console clear clicks');
      this.checkValue = 0
      this.shippingId = '';
      this.comments = '';
      this.Ismannual = false;
      this.keyFiredCount.value = 0
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.isCloseButtonUpload = false
      this.invalidFile = {};
      this.$validator.reset();
      this.errors.clear();
      $("#shippingId").focus();
    },
    buttonReset() {
      this.clearScanForm();
      this.scanFlag = false;
      this.getShipmentScanObj = {};
    },
    ResetForm(){
      this.keyFiredCount.value = 0
      this.getShipmentScanObj = [];
      this.scanFlag = false;
      this.$validator.reset();
      this.errors.clear();
    },
    resetFile() {
      const input = this.$refs.uploadfile;
      this.file = '';
      input.type = 'text';
      input.type = 'file';
      this.validated = true
      this.isCloseButtonUpload = false
      this.invalidFile = {};
      this.$alertify.success('File Removed Successfully');
    },
    removeFile(){

      if(this.file){
        if(this.shippingId !=''){
          let getextension = this.file.name.split(".");
          if(getextension.length != 0){
            let filePath = 'ScanTally/'+this.BatchNo+'/'+this.shippingId +'.' + getextension[1];
            let imgParamPayload = {
              "PathKey" : filePath
            }
            this.uploadLoading = true;
            axios.post(apiUrl.api_url_for_scantally + 'ScanTally/shipmentInscanAttachmentRemove', imgParamPayload)
             .then((response) => {
               //console.log('Remove Image response',response);
               if(response.data.code===200){
                 this.$alertify.success('File Removed Successfully');
                 this.file = '';
                 let imageRemoveObject = response.data.data;
               } else {
                 this.$alertify.error('file not deleted');
               }
               this.uploadLoading = false;
           })
           .catch((httpException) => {
             this.uploadLoading = false;
               this.$alertify.error("No Records Found");
               console.error('exception is:::::::::', httpException)
           })
          }

          const input = this.$refs.uploadfile;
          input.type = 'text';
          input.type = 'file';
          this.validated = true
          this.isCloseButtonUpload = false

        } else {
          this.$alertify.error('Please enter ShippingId')
        }
      }
    },
    changeDateFormat(){
      let current_datetime = new Date()
      let formatted_date = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + (current_datetime.getDate())).slice(-2);
      this.dateobj.toDate = formatted_date;
    },
    clear(){
      this.changeDateFormat();
      this.checkValue = 1
      //this.changeStatus = 1
      this.keyFiredCount.value = 0
      this.errormsg = [];
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.isCloseButtonUpload = false
      this.invalidFile = {};
      this.scanShipmentBatchFlag = false;
      this.shipmentDetailsFlag = false
      this.showBatchesFlag = false;
      this.exclude = "";
      this.Include = "";
      this.$validator.reset();
      this.errors.clear();
    },
    showUploadFileComments(){
      if(this.Ismannual == true) {
       this.checkValue = 1
      }else {
       this.checkValue = 0
      }
     this.changeStatus = 1
   },
   validateForm2(scope){

   },
   getScanTallyObject() {
    let syncDataKey = {
      "CurrentHubID": this.hubname
    }
    axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/new/configsettings', syncDataKey)
      .then((response) => {
        if (response.data.code == 200) {
          let featureData = response.data.data
          if (featureData.featureFlag == true){
            this.$router.push('/newAgentScanTally');
          }
        }
      })
  }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/AgentScanTally/AgentScanTally.component.js